var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlidsiconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5938_15740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5938 3.75H13.125V3.28125C13.125 2.50459 12.4954 1.875 11.7188 1.875H11.25V1.40625C11.25 0.62959 10.6204 0 9.84375 0H1.40625C0.62959 0 0 0.62959 0 1.40625V9.84375C0 10.6204 0.62959 11.25 1.40625 11.25H1.875V11.7188C1.875 12.4954 2.50459 13.125 3.28125 13.125H3.75V13.5938C3.75 14.3704 4.37959 15 5.15625 15H13.5938C14.3704 15 15 14.3704 15 13.5938V5.15625C15 4.37959 14.3704 3.75 13.5938 3.75ZM1.40625 10.3125C1.14735 10.3125 0.9375 10.1026 0.9375 9.84375V1.40625C0.9375 1.14735 1.14735 0.9375 1.40625 0.9375H9.84375C10.1026 0.9375 10.3125 1.14735 10.3125 1.40625V9.84375C10.3125 10.1026 10.1026 10.3125 9.84375 10.3125H1.40625ZM3.28125 12.1875C3.02235 12.1875 2.8125 11.9776 2.8125 11.7188V11.25H9.84375C10.6204 11.25 11.25 10.6204 11.25 9.84375V2.8125H11.7188C11.9776 2.8125 12.1875 3.02235 12.1875 3.28125V11.7188C12.1875 11.9776 11.9776 12.1875 11.7188 12.1875H3.28125ZM14.0625 13.5938C14.0625 13.8526 13.8526 14.0625 13.5938 14.0625H5.15625C4.89735 14.0625 4.6875 13.8526 4.6875 13.5938V13.125H11.7188C12.4954 13.125 13.125 12.4954 13.125 11.7188V4.6875H13.5938C13.8526 4.6875 14.0625 4.89735 14.0625 5.15625V13.5938Z",
    fill: "#203662"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5938_15740"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlidsiconActive);
export default __webpack_public_path__ + "static/media/slidsiconActive.d313c1913bf9bf3980b90f2b0709cfa2.svg";
export { ForwardRef as ReactComponent };